<template>
  <div class="app-layout" >

    <section class="app-layout-main">
      <app-body isNoSide/>
    </section>
  </div>
</template>

<script>
import {
  AppBody,
} from '@/components/index';

export default {
  name: 'Layout',
  components: {
    AppBody,
  },
};
</script>
